import type { TogglesDefinitions } from '../../types'

export class TogglesUpdatedEvent extends Event {
  public readonly detail: TogglesDefinitions

  constructor(toggles: TogglesDefinitions) {
    super(TogglesUpdatedEvent.name)
    this.detail = toggles
  }
}
